import { useSelector } from 'react-redux';
import { AnswersState } from 'schemas/answerStateSchema';
import { AnswersSelector } from 'store/selectors';

export enum AssetType {
  IMAGE = '/images',
  VIDEO = '/videos',
}

export function getAssetPath(
  assetType: AssetType,
  filePath: string,
  businessFolder: 'COMMON' | 'B2B' | 'B2C' = 'COMMON'
) {
  return `${process.env.PUBLIC_URL}${assetType}/${businessFolder}${filePath}`;
}

export function getAsset(
  type: AssetType,
  filePath: string,
  answers: AnswersState
) {
  const businessFolder = answers.businessChoice
    ? answers.businessChoice.toUpperCase()
    : 'B2C'; // let's default as B2C
  return getAssetPath(type, filePath, businessFolder as any);
}

export default function useAsset(type: AssetType, filePath: string) {
  const answers = useSelector(AnswersSelector) as AnswersState;
  return getAsset(type, filePath, answers);
}
